const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Username may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your username and password and try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
    changePasswordFailure:'Failed to change passwords. Check your old password and try again.',
	goalCopySuccess: "Goal logged, let's do this!",
	goalCopyFailure: 'Something went wrong, please try again!',
	yeyUpdated: 'Goal updated!',
	noAuth: 'Something went wrong, pls try again!',
	notFoundGoals: 'could not find any goals',
	cmntCreateEr: 'Something went wrong, we will be back soon',
	goalCompleted: "CONGRATS, I'M SO PROUD OF YOU!",
	goalLogged: "Goal logged, let's do this!",










}









module.exports = messages